import { render } from "./ApplicationLeads.vue?vue&type=template&id=88241034&scoped=true"
import script from "./ApplicationLeads.vue?vue&type=script&lang=js"
export * from "./ApplicationLeads.vue?vue&type=script&lang=js"

import "./ApplicationLeads.vue?vue&type=style&index=0&id=88241034&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-88241034"

export default script